import React from "react";
import TimeAgo from "react-timeago";

import { getThumbnailURL } from "~/src/api";

import { ListItem } from "~/src/components/global";

function ListItemMessage(props) {
  const { chat, inMessageHeader, dataCy } = props;
  const {
    studio, teacher, message, jobs,
  } = chat;

  let href = chat ? "/messages/[id]" : null;
  let as = chat ? `/messages/${chat.id}` : null;

  if (inMessageHeader && studio) {
    href = "/studios/[id]";
    as = `/studios/${studio.id}`;
  } else if (inMessageHeader && teacher) {
    href = "/teachers/[username]";
    as = `/teachers/${teacher.username}`;
  }

  const primaryText = studio ? studio.name : teacher ? teacher.firstname : "User";

  const messageText = message && message.text || `You haven’t messaged ${studio ? studio.name : teacher ? teacher.firstname : "this user"} yet.`;

  let jobsMarkup = null;
  if (jobs && jobs.length >= 2) {
    jobsMarkup = `Discussing ${jobs.length} jobs`;
  } else if (jobs && jobs.length === 1) {
    jobsMarkup = `Discussing “${jobs[0].name}”`;
  }

  return (
    <ListItem
      imageSrc={getThumbnailURL({ url: studio ? studio.photo : teacher ? teacher.photo : null })}
      primary={primaryText}
      secondary={inMessageHeader ? jobsMarkup : messageText}
      tertiary={inMessageHeader ? null : jobsMarkup}
      caption={inMessageHeader || !message ? null : <TimeAgo date={message.timestamp && message.timestamp.seconds && new Date(message.timestamp.seconds * 1000)} minPeriod={60} />}
      href={href}
      as={as}
      dataCy={dataCy}
    />
  );
}

export default ListItemMessage;
